import { render, staticRenderFns } from "./firmlogin.vue?vue&type=template&id=07ba7fc2&scoped=true"
import script from "./firmlogin.vue?vue&type=script&lang=js"
export * from "./firmlogin.vue?vue&type=script&lang=js"
import style0 from "./firmlogin.vue?vue&type=style&index=0&id=07ba7fc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ba7fc2",
  null
  
)

export default component.exports